export const uploadMinAllowedContentLength = 1024; // 1 kb
export const uploadMaxAllowedContentLength = 62914560; // 60mb
